import { useEffect, useState } from "react";
import { getFaqsByCategory } from "../services/faqService";
import FAQItem from "./faq/FAQItem";
import { getI18nLanguageFromLocalStorage } from "../helpers/localStorageHelper";
import { getLocalizedField } from "../helpers/localizedHelper";

export const FaqSection = ({ props }) => {
  const [filteredFaqs, setFilteredFaqs] = useState([]);
  const [expandedQuestionId, setExpandedQuestionId] = useState(null);
  const language = getI18nLanguageFromLocalStorage();

  useEffect(() => {
    const loadFaqs = async () => {
      if (true) {
        try {
          const filter = {
            first: 1,
            rows: 5,
            filters: null,
            multiSortMeta: [{
              field: "createdTime",
              order: -1,
            }],
          };
          const faqs = await getFaqsByCategory(filter);
          setFilteredFaqs(faqs.data);

        } catch (err) {
          // setIsError(translations.errorMessage);
        } finally {
        }
      }
    };

    loadFaqs();
  }, []);
  const toggleQuestion = (qId) => {
    setExpandedQuestionId((prev) => (prev === qId ? null : qId));
  };

  const handleLeaveMessage = () => {
    if (window.openLeaveMessagePopup) {
      window.openLeaveMessagePopup();
    } else {
      console.warn("openLeaveMessagePopup is not ready");
    }
  };

  return (
    <div>
      <div className="w-full">
        <div className="faq-banner-top-container relative">
          <div className="faq-banner-left absolute">
            <div className="keduall-typography heading-h1-semibold-600 text-white-txt">
              {props.faqOverview.bannerTitle}
            </div>
            <div className="keduall-typography heading-h1-semibold-600 text-white-txt">
              {props.faqOverview.bannerSubtitle}
            </div>
          </div>
          <div className="w-full h-28rem">
            <img
              src={props.faqBanner}
              alt="Banner"
              className="w-full h-28rem object-cover"
            />
          </div>
        </div>
      </div>
      <div className="w-full flex justify-content-center align-items-center">
        <div className="py-45 px-35 keduall-typography heading-h1-semibold-600 text-default-txt">{props.faqOverview.title} </div>
      </div>
      <div className="flex flex-column gap-6 w-full px-35 pb-45 pt-0 flex justify-content-center align-items-center">
        <div className="flex flex-column w-full gap-125">
          <div className="keduall-typography heading-h4-semibold-600 text-default-txt">{props.faqOverview.subtile}</div>
          <div>
            <div>
              {(filteredFaqs && filteredFaqs.length > 0) &&
                (
                  <div>
                    {
                      filteredFaqs.map((faq) => {
                        const isExpanded = expandedQuestionId === faq.id;
                        const question = getLocalizedField(faq, "question", language);
                        const answer = getLocalizedField(faq, "answer", language);
                        return (
                          <FAQItem
                            key={faq.id}
                            props={{ ...faq, question, answer }}
                            isExpanded={isExpanded}
                            onClick={toggleQuestion}
                          />
                        );
                      })
                    }
                  </div>
                )
              }
            </div>
          </div>
        </div>

        <div className="flex flex-row gap-45 px-45 w-full justify-content-center align-items-stretch flex-wrap md:flex-nowrap">
          <div className="flex flex-column px-45 py-35 gap-45 justify-content-between align-items-center border-primary-br border-radius-15 md:w-6 w-full">
            <div className="gap-125 flex flex-column justify-content-center align-items-center">
              <div className="keduall-typography heading-h1-semibold-600 text-default-txt">{props.faqOverview.card1.title}</div>
              <div className="keduall-typography heading-h5-normal-400 text-dark-txt">{props.faqOverview.card1.subtitle}</div>
            </div>
            <div onClick={() => { window.location.href = `faqs` }} className="flex flex-row justify-content-center align-items-center cursor-pointer">
              <div className="keduall-typography heading-h3-normal-400 text-default-txt">{props.faqOverview.card1.link}</div>
              <div className="pi pi-chevron-right text-primary-default font-size-1875"></div>
            </div>
          </div>

          <div className="flex flex-column px-45 py-35 gap-45 justify-content-between align-items-center border-primary-br border-radius-15 md:w-6 w-full">
            <div className="gap-125 flex flex-column justify-content-center align-items-center">
              <div className="keduall-typography heading-h1-semibold-600 text-default-txt">{props.faqOverview.card2.title}</div>
              <div className="keduall-typography heading-h5-normal-400 text-dark-txt">{props.faqOverview.card2.subtitle}</div>
            </div>
            <div onClick={handleLeaveMessage} className="flex flex-row justify-content-center align-items-center cursor-pointer">
              <div className="keduall-typography heading-h3-normal-400 text-default-txt">{props.faqOverview.card2.link}</div>
              <div className="pi pi-chevron-right text-primary-default font-size-1875"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
